import { Component, ViewEncapsulation } from '@angular/core';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {environment} from '../../../../environments/environment';

@Component({
    selector     : 'quick-panel',
    templateUrl  : './quick-panel.component.html',
    styleUrls    : ['./quick-panel.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class QuickPanelComponent
{
    appVersion: string;
    currentLocale: string;
    date: Date;
    events: any[];
    notes: any[];
    settings: any;

    /**
     * Constructor
     */
    constructor(
        private translateService: TranslateService
    )
    {
        // Set the defaults
        this.date = new Date();
        this.settings = {
            notify: true,
            cloud : false,
            retro : true
        };
        this.appVersion = environment.version;
        this.currentLocale = this.translateService.currentLang;
        this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            this.currentLocale = this.translateService.currentLang;
        });

    }
}
